import React from 'react';
import { Box, Typography } from '@mui/material';
import GenericLoader from '../../components/Loader/GenericLoader';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';

import { useSelector } from 'react-redux';
import { AssetsTabs } from './AssetsTabs';
import { TimesheetsComponentLoaderAttribute } from '../../constants';

const AssetsComponent = (props) => {
  const tab = useSelector((state) => state.assetsTabState);
  const [loader, setLoader] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(tab);
  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader rectAttributes={TimesheetsComponentLoaderAttribute} />
        </div>
      ) : (
        <Box className="main-content-overlay">
          <div className="main-content-div">
            <div className="head-title-text">
              <Typography variant="h5" component="div">
                Assets
              </Typography>
            </div>
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={AssetsTabs}
            />
          </div>
        </Box>
      )}
    </div>
  );
};
export default AssetsComponent;
